import { useAuth } from "@/hooks/useAuth"
import OrganizationHeader from "./features/Header"
import OrganizationsList from "./features/OrganizationsList"
import AdminOrganizationsList from "./features/admin/AdminOrganizationsList" // Restore this import
// import AdminDashboardPage from "../AdminDashboard"; // Remove this import

const OrganizationsPage = () => {
  const { user } = useAuth()

  return (
    <div className="flex flex-col z-0">
      <OrganizationHeader />
      {user ? (
        user.isAdmin ? (
          <AdminOrganizationsList /> // Restore AdminOrganizationsList for admins
        ) : (
          <OrganizationsList /> // Regular users see their list
        )
      ) : null}
    </div>
  )
}

export default OrganizationsPage
